import { instalarShimAssetsVlibrasJsdelivr } from '@/core/utils/vlibras-jsdelivr-asset-shim';

instalarShimAssetsVlibrasJsdelivr();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@cotin/biblioteca-componentes-react';
import '@cotin/biblioteca-componentes-react/theme.css';
import './styles/layer-order.css';
import '@cotin/biblioteca-componentes-react/componentes.css';
import './index.css';
import './styles/layout/index.scss';
import App from './App';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </StrictMode>
);
